import { mq } from '../../../cssInJs'

export default {
  orderDetails: {
    textAlign: 'left',
    marginBottom: '6rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    marginTop: '3rem',
    paddingBottom: '3rem'
  },
  summary: {

  },

  fn: mq({
    minWidth: ['7rem', null, '10em'],
    margin: 0
  }),
  fv: {

  },

  orderItems: {},
  orderItem: {
    padding: '0.5rem 0',
    margin: '0.5rem 0',
    borderBottom: 'solid 1px #ccc'
  },
  total: {
    //marginLeft: 15,
    fontWeight: 'bold',
    color: 'chocolate'
  },
  button: {
    display: 'inline-block',
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#d1ab6c',
    padding: '.3rem 1rem',
    marginTop: '1rem',
    '&:hover': {
      backgroundColor: '#084d8f',
      color: '#fff',
      textDecoration: 'none'
    }
  }
}
